var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.203 4.64657L13.6009 13.8272C15.216 18.2759 16.0661 20.5143 16.0378 20.5427C15.4994 22.0728 14.6493 20.5993 13.7709 21.0244L13.1476 21.3361L11.2208 16.9724L6.34708 22.1861L5.24201 21.7611L4.81698 22.1861C4.44862 22.0161 4.10859 21.7611 3.74023 21.4494C5.157 18.7292 7.42382 16.4341 9.43563 14.1389L6.31875 7.8768C6.31875 7.3951 6.68711 6.9134 7.42382 6.4317L7.14047 6.09167C7.31048 5.58164 7.62217 5.35496 8.10387 5.35496C8.64224 5.35496 9.88899 7.11174 11.8441 10.6537L16.9161 2.71977C17.6245 1.64303 19.608 1.41635 19.608 2.71977C20.0614 3.39982 19.3813 3.82485 20.1747 4.67491L20.203 4.64657Z",
    fill: "#D4C1A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.a50fe5f1b56f4512f63c9050f08f9184.svg";
export { ForwardRef as ReactComponent };